<template>
    <div>
        <v-dialog
        content-class="dialog-custom"
        width="400px"
        height="400px"
        v-model="show"
        persistent>
        <v-card light >
                <v-card-title>
                    <div class="dialog-header-custom">
                        <div>
                            <v-btn
                                class="closeButton mx-2"
                                icon
                                title="Close Form"
                                @click="handleClose"
                            >
                                <v-icon style="color: #4f4f4f !important" class="material-icons-round">close</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </v-card-title>
                <v-card-text>
                    <div class = "logoutContainer">
                        <p><img src='/img/Failure.png'></p>
                        <p class = "logoutText">Service unavailable</p>
                        <p class = "sureLogoutText">{{ message }}</p>
                        <div class = "buttonContainer">
                            <button class="buttonSubmit btn_new btn-secondary-new" @click="handleClose">Try Again</button>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'FailureDialog',
    props: {
        message: String
    },
    data: () => ({
        show: true
    }),
    methods: {
        handleClose () {
            this.$emit('handleClose')
        }
    }
}
</script>
<style lang="scss" scoped>
p{
    margin-bottom: 6px;
    align-items: center;
    text-align: center;
}
.buttonContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}
.buttonSubmit {
  height: 44px !important;
  font-size: 14px !important;
  width: 100% !important;
}
.closeButton {
    position: absolute;
    right: 0px;
    margin-top: 5px;
    margin-right: -8px !important;
}
.sureLogoutText {
    margin-bottom: 40px;
    font-weight: 400;
    font-size: 14px;
    color: #4F4F4F;
}
.logoutText {
    font-weight: 600;
    font-size: 20px;
    color: #232323;
}
.logoutContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.dialog-custom {
    background: #ffffff;
    border: 1px solid #b9b9bb !important;
    box-sizing: border-box !important;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
    border-radius: 20px !important;
    max-width:30%;
    @media screen and (max-width: 400px) {
        max-width:10%;
    }
    .v-card__actions {
        padding: 20px !important;
    }
}

.v-text-field .v-label {
    font-weight: bold !important;
}
.dialog-header-custom {
    position:relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
}
</style>
